import { Flex } from '@chakra-ui/react';
import colors from 'src/theme/colors';
import { useFetchEpisodes } from 'src/pages/episodes/hooks/useFetchEpisodes';
import { LifecycleState } from 'src/generated/graphql';
import { useEpisodesPageContext } from '../../EpisodesPageContext';
import FilterButton from './FilterButton';

export default function EpisodesFilter() {
  const [{ filter }, dispatch] = useEpisodesPageContext();
  const { filterCount } = useFetchEpisodes();

  function onSetFilter(filterType: typeof filter.type) {
    dispatch({
      type: 'set-filter',
      filter: { ...filter, lifecycleState: undefined, type: filterType },
    });
  }

  return (
    <Flex
      borderTop={`1px solid ${colors.podcastShade200}`}
      w="100%"
      gridColumn="span 2"
      gridGap="30px"
    >
      <FilterButton
        text="all episodes"
        count={filterCount?.all}
        isSelected={filter.type === undefined && filter.lifecycleState === undefined}
        onClick={() => onSetFilter(undefined)}
      />
      <FilterButton
        text="drafts"
        count={filterCount?.draft}
        isSelected={filter.lifecycleState === LifecycleState.Draft}
        onClick={() =>
          dispatch({
            type: 'set-filter',
            filter: { ...filter, type: undefined, lifecycleState: LifecycleState.Draft },
          })
        }
      />
      <FilterButton
        text="processing"
        count={filterCount?.processing}
        isSelected={filter.type === 'processing'}
        onClick={() => onSetFilter('processing')}
      />
      <FilterButton
        text="processed"
        count={filterCount?.complete}
        isSelected={filter.type === 'complete'}
        onClick={() => onSetFilter('complete')}
      />
    </Flex>
  );
}
